import Adapter from "./Adapter/Adapter";

if (window) {
  window.SolanaAdapter = Adapter;
}

export default Adapter;
